/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomComponentLibrariesLibraryIdGet200ResponseData } from './CustomComponentLibrariesLibraryIdGet200ResponseData';
import {
    CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON,
    CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSONTyped,
    CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON,
} from './CustomComponentLibrariesLibraryIdGet200ResponseData';

/**
 * A paginated list of custom component libraries.
 * @export
 * @interface CustomComponentLibrariesGet200Response
 */
export interface CustomComponentLibrariesGet200Response {
    /**
     * API request succeeded
     * @type {boolean}
     * @memberof CustomComponentLibrariesGet200Response
     */
    success: boolean;
    /**
     * An array of requested items
     * @type {Array<CustomComponentLibrariesLibraryIdGet200ResponseData>}
     * @memberof CustomComponentLibrariesGet200Response
     */
    data: Array<CustomComponentLibrariesLibraryIdGet200ResponseData>;
    /**
     * Total number of items in the response
     * @type {number}
     * @memberof CustomComponentLibrariesGet200Response
     */
    totalCount: number;
    /**
     * A token to retrieve the next page of items in the collection
     * @type {string}
     * @memberof CustomComponentLibrariesGet200Response
     */
    nextToken: string | null;
    /**
     * Whether there are more items in the collection
     * @type {boolean}
     * @memberof CustomComponentLibrariesGet200Response
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the CustomComponentLibrariesGet200Response interface.
 */
export function instanceOfCustomComponentLibrariesGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "nextToken" in value;
    isInstance = isInstance && "hasMore" in value;

    return isInstance;
}

export function CustomComponentLibrariesGet200ResponseFromJSON(json: any): CustomComponentLibrariesGet200Response {
    return CustomComponentLibrariesGet200ResponseFromJSONTyped(json, false);
}

export function CustomComponentLibrariesGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': ((json['data'] as Array<any>).map(CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON)),
        'totalCount': json['total_count'],
        'nextToken': json['next_token'],
        'hasMore': json['has_more'],
    };
}

export function CustomComponentLibrariesGet200ResponseToJSON(value?: CustomComponentLibrariesGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'data': ((value.data as Array<any>).map(CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON)),
        'total_count': value.totalCount,
        'next_token': value.nextToken,
        'has_more': value.hasMore,
    };
}

